module.exports = __webpack_public_path__ + "img/SI1319175.2651a42f.jpeg";